// extracted by mini-css-extract-plugin
export default {"topWrapper":"_91373718","title":"_5989d0e0 _13d685ec","tileWrapper":"_40ba37c7","viewAllLink":"_95655a0c"};